module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/domofon-3-8452bb124bb8a81752bac2674a52edb2.webp";